export function isErrorIgnorable(status?: number): boolean {
  if (status && 400 <= status && status <= 499) {
    return true;
  }
  return false;
}
